export default {
  interface: {
    funding: {
      round: 'Round',
      funding_amount: 'Funding Amount',
      valuation: 'Valuation',
      lead_investor: 'Lead Invested',
    },
    image: 'Image',
    show_more: 'Show More',
    max_20_chars: 'Maximum 20 characters',
    max_400_chars: 'Maximum 400 characters',
    ai_inspiration_hub: 'AI Inspiration Hub',
    weekly_pick: 'Weekly Picks',
    loading_data: 'Loading data…',
    dateNav: {
      year: 'Year',
      month: 'Month',
      allTime: 'All time',
      jump: 'Year/Month',
      collapse: 'Collapse',
      day: 'Day',
      selectDay: 'Select day',
      allDays: 'All days',
      weekRange: '{sm} {sd} - {em} {ed}',
      dayFormat: '{day}',
    },
    months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    share: {
      card_button: 'Share',
      title: 'Share Card',
      sharer: 'Sharer',
      sharerPlaceholder: 'Your name (optional)',
      message: 'Message',
      messagePlaceholder: 'Your thoughts about this product (optional)',
      generate: 'Generate Card',
      generating: 'Generating...',
      cancel: 'Cancel'
    },
    nav: {
      home: 'AI Products',
      funding: 'AI Funding',
    },
    pageTitle: {
      home: 'AI Products - AI Inspiration Hub',
      tag: '{tag} Related Products - AI Inspiration Hub',
    },
    title: {
      home: 'AI Products',
      funding: 'AI Funding Updates',
      search: 'Search: "{query}"',
      tag: '{tag} Related Products',
      exportChannels: 'Global Launch Channels',
      tools: 'Useful Tools'
    },
    search: {
      placeholder: 'Search AI Products...',
      button: 'Search',
      noResults: {
        title: 'Sorry, no results found',
        suggestion: 'Please try searching with different keywords'
      }
    },
    product: {
      visit_website: 'Visit {name} Website',
      logo_alt: '{name} logo',
      preview_image: '{name} Product Preview Image {index}/{total}',
      preview_image_full: '{name} Product Preview Image (Full Size) {index}/{total}',
      view_more_tag: 'View More {tag} Related Products'
    }
  },
  channel: {
    scale: 'Scale'
  },
  meta: {
    description: 'AI Inspiration Hub provides the latest and most comprehensive AI products and tools to help you find product inspiration and workflow tools',
    tagDescription: 'Explore {tag}-related AI products and tools, discover innovative solutions',
    keywords: {
      home: 'bestreader.ai, AI Inspiration Hub, AI tools, AI products, AI application, AI app, AI resources, artificial intelligence tools, AI development, creative tools, workflow optimization, startup, indie development',
      tag: '{tag}, AI tools, AI products, AI application, AI app, AI resources, artificial intelligence, innovative tools, intelligent applications'
    }
  }
}
